import { Component, FormEvent } from 'react';
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock, Alert } from 'react-bootstrap';
import { IMoveTracker } from '@nkr/models/index';

interface IProps {
    show: boolean,
    data: IMoveTracker,
    onSave: (chainId: number, clusterNumber: number, positionNumber: number, issueDescription: string, planDescription: string) => void,
    onCancel: () => void
}

interface IState {
    issue: string,
    plan: string,
    valid: {
        issue: boolean,
        plan: boolean
    },
    dirty: boolean
}

class AcknowledgeAlert extends Component<IProps, IState> {
    readonly state: IState = {
        issue: '',
        plan: '',
        valid: {
            issue: true,
            plan: true
        },
        dirty: false
    }

    componentWillReceiveProps = (nextProps: IProps) => {
        if (nextProps.show != this.props.show) {
            this.setState({
                issue: '',
                plan: '',
                valid: {
                    issue: true,
                    plan: true
                }
            });
        }
    }

    handleIssueChange = (e: FormEvent<FormControl & HTMLTextAreaElement>) => {
        let valid = { ...this.state.valid };

        if (this.state.dirty) {
            valid.issue = e.currentTarget.value != '';
        }

        this.setState({
            issue: e.currentTarget.value,
            valid
        });
    }

    handlePlanChange = (e: FormEvent<FormControl & HTMLTextAreaElement>) => {
        let valid = { ...this.state.valid };

        if (this.state.dirty) {
            valid.plan = e.currentTarget.value != '';
        }

        this.setState({
            plan: e.currentTarget.value,
            valid
        });
    }

    handleSave = () => {
        let { issue, plan } = this.state

        this.setState({
            valid: {
                issue: issue != '',
                plan: plan != ''
            },
            dirty: true
        }, () => {
            let isValid = this.state.valid.issue && this.state.valid.plan;

            if (isValid) {
                let { chainId, clusterNumber, positionNumber } = this.props.data;
                this.props.onSave(chainId, clusterNumber, positionNumber, issue, plan);
            }
        });
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const { chainId, clusterNumber, positionNumber } = this.props.data;

        return (
            <Modal backdrop='static' show={this.props.show} onHide={this.handleCancel}>
                <Modal.Header closeButton>
                    <Modal.Title>Alert Details for Swap {chainId}/{clusterNumber}/{positionNumber}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {(!this.state.valid.issue || !this.state.valid.plan) && (
                        <Alert bsStyle='danger'>
                            Please fix the issues below...
                        </Alert>
                    )}

                    <FormGroup validationState={!this.state.valid.issue ? 'error' : null}>
                        <ControlLabel>What is the issue with this swap?</ControlLabel>
                        <FormControl
                            componentClass='textarea'
                            style={{ resize: 'none' }}
                            rows={7}
                            value={this.state.issue}
                            onChange={this.handleIssueChange}
                        />
                        {!this.state.valid.issue && (
                            <HelpBlock>Please specify the issue...</HelpBlock>
                        )}
                    </FormGroup>

                    <FormGroup validationState={!this.state.valid.plan ? 'error' : null}>
                        <ControlLabel>What is the plan going forward?</ControlLabel>
                        <FormControl
                            componentClass='textarea'
                            style={{ resize: 'none' }}
                            rows={7}
                            value={this.state.plan}
                            onChange={this.handlePlanChange}
                        />
                        {!this.state.valid.plan && (
                            <HelpBlock>Please specify the plan...</HelpBlock>
                        )}
                    </FormGroup>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.handleSave}>Acknowledged</Button>
                    <Button onClick={this.handleCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default AcknowledgeAlert;